<div class="templateB">


    @if(_templateData.header){
        <div style="text-align: center;">
            <h1 style="margin-bottom: 0.05em;">{{_templateData.header.title}}</h1>
            <h3 style="margin-top: 0.05em;">{{_templateData.header.subTitle}}</h3>
            <div>
                @for(line of _templateData.header.lineItems; track line){
                    {{line}}<br>
                }
            </div>
        </div>
        <br>
    }

    @if (_templateData.bodyText) {
        <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
            <div style="width: 75vw;" [innerHtml]="safeHtmlBody"></div>
        </div>
        <br>
    }


    @if (_templateData.context) {
        <div style="display: flex;  flex-wrap: wrap; justify-content: center; align-items: stretch; width: 100%;">

            <mat-card (click)="previousSection()" style="min-width: 35px; max-width: 35px; margin: 5px; display: flex; justify-content: center; align-items: center">
                <mat-icon>arrow_back</mat-icon>
            </mat-card>

                @for (section of currentSelections; track section) {

                    <mat-card style="min-width: 250px; max-width: 250px; margin: 5px;">

                        @if(!_templateData.context[section].more) {
                            <div style="max-width: 100%; height: auto; overflow: hidden">
                                <div style="width: 100%; height: auto; display: block;">
                                    <img  src="{{_templateData.context[section].image}}" width="100%">
                                </div>
                            </div>

                            <mat-card-header>
                                <div mat-card-avatar > <mat-icon>{{_templateData.context[section].icon}}</mat-icon></div>
                                <mat-card-title>{{_templateData.context[section].title}}</mat-card-title>
                                <mat-card-subtitle>{{_templateData.context[section].subTitle}}</mat-card-subtitle>
                            </mat-card-header>
                        }

                        @if(!_templateData.context[section].more) {
                            <mat-card-content>
                                <p>{{_templateData.context[section].body}}</p>
                            </mat-card-content>
                        } @else {
                            <mat-card-content>
                                <p>{{_templateData.context[section].moreBody}}</p>
                            </mat-card-content>
                        }

                        <mat-card-actions>
                            @if (_templateData.context[section].button){
                                @if (_templateData.context[section].moreBody){
                                    @if (!_templateData.context[section].more){
                                        <button mat-button (click)="onMoreButtonClick(_templateData.context[section])">Show me more</button>
                                    } @else {
                                        <button mat-button (click)="onMoreButtonClick(_templateData.context[section])">Show me less</button>
                                    }
                                }
                                @if (!_templateData.context[section].more){
                                    <button mat-button (click)="onButtonClick(_templateData.context[section].button.buttonURL)">{{_templateData.context[section].button.buttonText}}</button>
                                }
                            }
                        </mat-card-actions>
                    </mat-card>
                }
            <mat-card (click)="nextSection()" style="min-width: 35px; max-width: 35px; margin: 5px; display: flex; justify-content: center; align-items: center">
                <mat-icon >arrow_forward</mat-icon>
            </mat-card>
        </div>

    }

    @if(_templateData.footer){
        <div style="text-align: center;">
            <h1 style="margin-bottom: 0.05em;">{{_templateData.footer.title}}</h1>
            <h3 style="margin-top: 0.05em;">{{_templateData.footer.subTitle}}</h3>
            <div>
                @for(line of _templateData.footer.lineItems; track line){
                    {{line}}<br>
                }
            </div>
        </div>
        <br>
    }

</div>